type GetCategoryBannerTitleArgs = {
  query: URLSearchParams;
  displayName: string;
};

const getCategoryBannerTitle = ({ query, displayName }: GetCategoryBannerTitleArgs) => {
  return query.get('q') ? `"${query.get('q')}" templates` : displayName;
};

export default getCategoryBannerTitle;
